"use client";

import { getImageUrl } from '@/lib/imageUrl';
import Image from 'next/image';
import BusinessOutcomes from './BusinessOutcomes';

export default function WeLove() {
  return (
    <div className="h-full bg-[#FEFEFE] relative overflow-hidden">
      {/* Background blur effect */}
      <div className="absolute left-1/2 -translate-x-1/2 -top-32 sm:-top-40 md:-top-48 lg:-top-56 w-full max-w-[1289px] h-[280px] sm:h-[320px] md:h-[350px] lg:h-[382px] bg-[#FFF9DC] rounded-[1289px] blur-[80px] pointer-events-none"></div>


      {/* Main content container */}
      <div className="w-full relative">
        {/* Hero section */}
        <div className="pt-[40px] md:pt-[80px]">
          <div className="w-full max-w-4xl mx-auto text-center">
            {/* Main heading */}
            <h2 className="
                text-center
                font-NeueMontreal
                text-[30px] sm:text-3xl md:text-4xl lg:text-5xl xl:text-[48px]
                font-semibold
                leading-[120%]
                mb-6
                px-2 tracking-wide
                ">
              <span className="text-[#090D28] font-NeueMontreal  text-[30px] sm:text-3xl md:text-4xl lg:text-5xl xl:text-[48px]">
                Born in{' '}
              </span>

              <span className="
                    bg-[linear-gradient(90deg,#F7B831_0%,#F12979_61.54%)]
                     text-[30px] sm:text-3xl md:text-4xl lg:text-5xl xl:text-[48px]
                    font-NeueMontreal
                    bg-clip-text
                    text-transparent
                ">
                Tamil Nadu -
              </span>
              <br className='md:hidden block' />
              <span className="text-[#090D28] font-NeueMontreal  text-[30px] sm:text-3xl md:text-4xl lg:text-5xl xl:text-[48px]">
                {' '} Built for the{' '}
              </span>

              <span className="
                    bg-[linear-gradient(90deg,#31B6F8_76.44%,#6717F0_100%)]
                    font-NeueMontreal
                     text-[30px] sm:text-3xl md:text-4xl lg:text-5xl xl:text-[48px]
                    bg-clip-text
                    text-transparent
                ">
                World
              </span>
            </h2>


            {/* Description paragraph */}
            <p className="schibsted-grotesk  text-sm tracking-wide sm:text-base md:text-lg font-[400] leading-[150%] text-[#090D28] opacity-70 mb-4 sm:mb-5 md:mb-6 max-w-[1600px] mx-auto px-2 sm:px-4">
              We started our journey in 2015 from a small room in Chennai, with one simple belief: Great technology should not just be born in Silicon Valley. It can rise from the soil of Tamil Nadu and touch every corner of the planet. We were the first company in India to proudly stamp “Made in Tamil Nadu” on every product we build, long before it became a trend. Our code, our designs, our servers in Mumbai and Singapore, and every line of support we give carry the spirit of Tamil heritage: hard work, integrity, compassion, and the quiet confidence that says “If we dream it, we will deliver it.”
            </p>

            {/* Learn more button */}
            <a href='/about-us' aria-label='About us Redirect url' className="inline-flex schibsted-grotesk h-10 sm:h-11 md:h-12 rounded-[8px] items-center justify-center px-4 sm:px-5 md:px-6  text-[#195AFF] text-base sm:text-lg font-medium leading-[120%]  active:bg-gray-100 transition-colors shadow-[0_1px_3px_0_rgba(25,90,255,0.10),-2px_5px_6px_0_rgba(25,90,255,0.09),-4px_12px_8px_0_rgba(25,90,255,0.05),-7px_21px_9px_0_rgba(25,90,255,0.01),-11px_34px_10px_0_rgba(25,90,255,0.00)]">
            Read Our Story 
            </a>
          </div>
        </div>

       <BusinessOutcomes />

      </div>
    </div>
  );
}
